import React from 'react'
import { Document } from './styles'
import { Message } from '../type'
import Text from '../../Text'

interface Props {
  type: 'sent' | 'received'
  message: Message
}

const DocumentMessage: React.FC<Props> = ({ message }) => {
  return (
    <Document
      href={message.upload?.url}
      target="_blank"
      rel="noopener noreferrer"
      download={message.upload?.name}
    >
      <img
        src="../../../assets/file.png"
        height="16"
        width="12"
        alt=""
      />
      <Text
        tag="span"
        color="blue"
      >
        {message.upload?.name}
      </Text>
    </Document>
  )
}

export default DocumentMessage
